// extracted by mini-css-extract-plugin
export const sectionTwoColCta = "twoColCta-module--sectionTwoColCta--kkIeW";
export const sectionInverse = "twoColCta-module--sectionInverse--3_juR";
export const sectionContainer = "twoColCta-module--sectionContainer--10xjQ";
export const sectionFirstCol = "twoColCta-module--sectionFirstCol--1wsJJ";
export const sectionSecondCol = "twoColCta-module--sectionSecondCol--rG5kQ";
export const imageWrapper = "twoColCta-module--imageWrapper--3Cgs6";
export const sectionContent = "twoColCta-module--sectionContent--1_317";
export const sectionCta = "twoColCta-module--sectionCta--3btCE";